export default __webpack_public_path__ + "static/media/steve.0bfc18e4.jpg";